import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AppEnum from "./models/appEnum";
import weixin from "./tools/weixin";
import VueClipboard from 'vue-clipboard2'
import vueTips from 'vue-tips'

//引入vant组件
import { Tabbar,TabbarItem, NavBar,  Image, Icon, Grid, GridItem, Row, Col, DropdownMenu, DropdownItem, DatetimePicker, Picker, Cell, CellGroup, SwipeCell, Field, Popup, Button, Checkbox, CheckboxGroup, Swipe, SwipeItem, ActionSheet, CountDown, Uploader, RadioGroup, Radio, Search, Tab, Tabs, Divider, Tag, List,PullRefresh,Toast} from 'vant';
Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Image).use(Icon).use(Grid).use(GridItem).use(Row).use(Col).use(DropdownMenu).use(DropdownItem).use(DatetimePicker).use(Picker).use(Cell).use(CellGroup).use(SwipeCell).use(Field).use(Popup).use(Button).use(Checkbox).use(CheckboxGroup).use(Swipe).use(SwipeItem).use(ActionSheet).use(CountDown).use(Uploader).use(RadioGroup).use(Radio)
.use(Search).use(Tab).use(Tabs).use(Divider).use(Tag).use(List).use(PullRefresh).use(Toast);

import { IndexBar, IndexAnchor } from 'vant';
Vue.use(IndexBar).use(IndexAnchor);

import { Step, Steps, Stepper, NoticeBar, Overlay, Dialog,Switch,Empty } from 'vant';
Vue.use(Step).use(Steps).use(Stepper).use(NoticeBar).use(Overlay).use(Dialog).use(Switch).use(Empty);

import { Area } from 'vant';
Vue.use(Area);

//富文本编辑
import initRichText from './assets/js/initHTMLEditor.js';
initRichText();
import 'font-awesome/css/font-awesome.min.css';

//视频播放器组件
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

//瀑布流
import waterfall from "vue-waterfall2";
Vue.use(waterfall)

// 时间格式处理
import moment from 'moment'
Vue.prototype.$moment = moment

import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import './assets/font/iconfont.css'
Vue.use(vueTips)

Vue.use(VueClipboard);
Vue.prototype.appEnum=new AppEnum();
Vue.prototype.$weixin=weixin;
Vue.prototype.$toast=Toast;
Vue.prototype.$tips=vueTips;
Vue.config.productionTip = false

// const sess=window.sessionStorage;

// Vue.mixin({
//   beforRouteLeave(to,from,next){
//     console.log("beforRouteLeave");
//     console.log(to);
//     const toRoute=to.path;
//     const fromRoute=from.path;
//     const h=JSON.parse(sess.getItem(toRoute));
//     if(h&&h.history)
//     {
//         this.$destroy();
//         next();
//     }
//     else{
//       next();
//     }
//   }
// })

// const beforeEach=function(to,from,next){
//   console.log("beforeEach");
//   const toRoute=to.path;
//   const fromRoute=from.path;
//   let h=JSON.parse(sess.getItem(toRoute));
//   console.log(h);
//   if(h&&h.history)
//   {
//       h.history=false;
//       sess.removeItem(toRoute);
//   }
//   else{
//     sess.setItem(
//       fromRoute||'/',JSON.stringify({history:true})
//     )
//   }
//   next();
// }
// router.beforeEach(beforeEach)


Vue.prototype.$back = function (){
  if (window.history.length <= 1) {
      this.$router.push({path:'/'})
      return false
  } else {
      this.$router.go(-1)
  }
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
